import React from 'react';
import PropTypes from 'prop-types';

import IconForward from './svg/IconForward';

function ButtonForwardPreview({ id, size = 20, className, style, onClick }) {
  const overrideClick = (e) => {
    if (onClick) { onClick(e); }
  }
  return (
    <div id={id} onClick={overrideClick} className={`button-forward-preview ${className}`} style={{...style, cursor: 'pointer'}}>
      <IconForward size={size} />
    </div>
  )
}

ButtonForwardPreview.propTypes = {
  id: PropTypes.any.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default ButtonForwardPreview;
